import React, { useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isSubscribing, setIsSubscribing] = useState(false);
  const navigate=useNavigate();
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setIsSubscribing(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsSubscribing(false);
      setEmail('');
    }, 2000);
  };

  const quickLinks = [
    { name: 'Buy Property', href: '/properties?status=available' },
    { name: 'Sell Property', href: '/contact?subject=selling' },
    { name: 'Rent Property', href: '/properties?status=rented' },
    { name: 'Market Reports', href: '/blog?category=market-trends' },
    { name: 'Investment Guide', href: '/blog?category=investment' }
  ];

  const propertyTypes = [
    { name: 'Luxury Homes', href: '/properties?propertyType=house&budget=over-5m' },
    { name: 'Apartments', href: '/properties?propertyType=apartment' },
    { name: 'Condos', href: '/properties?propertyType=condo' },
    { name: 'Commercial', href: '/properties?propertyType=commercial' },
    { name: 'Land & Lots', href: '/properties?propertyType=land' },
    { name: 'New Construction', href: '/properties?yearBuilt=2024' }
  ];

  const resources = [
    { name: 'Assetz Meru & Meadow', href: '/docs/mm.pdf' },
    { name: 'Assetz Zen ', href:'/docs/zs' },
    { name: 'Gardenia', href: '/docs/cg.pdf' },
    {name:"Marathahalli",href:'/docs/cm.pdf'},
    { name: 'Hamlet Analysis', href: '/docs/cha.pdf' },
    { name: 'Micropolis Analysis', href: '/docs/cma.pdf' },
    { name: 'Sadahalli', href: '/docs/cs.pdf' },
    
  ];

  const companyLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Our Team', href: '/agents' },
    { name: 'Careers', href: '/careers' },
    { name: 'Press & Media', href: '/press' },
    { name: 'Success Stories', href: '/testimonials' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', href: '/docs/ThinkRealty_PrivacyPolicy.pdf' },
    { name: 'Terms of Service', href: '/docs/ThinkRealty_TermsOfService.pdf' },
    {name:'GST certificate',href:'/docs/gst.pdf'},
    {name:"RERA Cetificate",href:'/docs/rera.jpg'},
    {name:'Nambiar District 25 Project Report',href:'/docs/ndpr.pdf'}
  ];

 
  const socialLinks = [
    { 
      name: 'Facebook', 
      href: 'https://facebook.com/THINKREALTY',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    { 
      name: 'Instagram', 
      href: 'https://instagram.com/THINKREALTY',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.743 3.708 12.446s.49-2.449 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.874 1.297 2.026 1.297 3.323s-.49 2.449-1.297 3.323c-.875.807-2.026 1.297-3.323 1.297zm7.718 0c-1.297 0-2.448-.49-3.323-1.297-.807-.874-1.297-2.026-1.297-3.323s.49-2.449 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.874 1.297 2.026 1.297 3.323s-.49 2.449-1.297 3.323c-.875.807-2.026 1.297-3.323 1.297z"/>
        </svg>
      )
    },
    { 
      name: 'LinkedIn', 
      href: 'https://linkedin.com/company/THINKREALTY',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    },
    { 
      name: 'Twitter', 
      href: 'https://twitter.com/THINKREALTY',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      )
    },
    { 
      name: 'YouTube', 
      href: 'https://youtube.com/THINKREALTY',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      )
    }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-900 to-black text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-500/5 rounded-full blur-3xl"></div>
      
     

      {/* Main Footer Content */}
      <div className="relative z-10 py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-6 gap-12">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center space-x-4 mb-8 group">
               
                <div>
                  <div className="text-2xl font-bold">
                    Think<span className="text-red-700">Real</span>ty
                  </div>
                   {/* Copyright */}
            <div className="text-center lg:text-left">
              <p className="text-gray-400">
                © 2025 THINKREALTY. All rights reserved. | 
                <span className="text-blue-400 ml-1">Licensed Real Estate Brokerage</span>
              </p>
              <p className="text-sm text-gray-500 mt-1">
                Equal Housing Opportunity | MLS #12345 | License #RE123456789
              </p>
            </div>

           
                </div>
              </Link>
              
              <p className="text-gray-300 leading-relaxed mb-8 text-lg">
                Your trusted partner in luxury real estate. We specialize in connecting discerning clients with exceptional properties that exceed expectations.
              </p>
              
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xl font-bold mb-8 text-white">Quick Links</h4>
              <ul className="space-y-4">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link 
                      to={link.href}
                      className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center group"
                    >
                      <svg className="w-4 h-4 mr-3 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                      <span className="group-hover:translate-x-2 transition-transform duration-300">{link.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Property Types */}
            <div>
              <h4 className="text-xl font-bold mb-8 text-white">Property Types</h4>
              <ul className="space-y-4">
                {propertyTypes.map((type) => (
                  <li key={type.name}>
                    <Link 
                      to={type.href}
                      className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center group footer-links"
                    >
                      <svg className="w-4 h-4 mr-3 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                      <span className="group-hover:translate-x-2 transition-transform duration-300">{type.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources */}
            <div className="lg:col-span-2">
  <h4 className="text-xl font-bold mb-8 text-white">Resources</h4>
  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8">
    {resources.map((resource) => (
      <li key={resource.name}>
        <a
          href={resource.href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center group"
        >
          <svg
            className="w-4 h-4 mr-3 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
          <span className="group-hover:translate-x-2 transition-transform duration-300">
            {resource.name}
          </span>
        </a>
      </li>
    ))}
  </ul>
</div>   
          </div>
  <div className="flex flex-col lg:flex-row items-center justify-between space-y-6 lg:space-y-0 mt-2">
                   
 {/* Legal Links */}
            <div className="flex flex-wrap items-center justify-center lg:justify-end gap-x-6 gap-y-2">
              {legalLinks.map((link, index) => (
                <React.Fragment key={link.name}>
                  <a
                    href={link.href}
  target="_blank"
  rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                  {index < legalLinks.length - 1 && (
                    <span className="text-gray-600 hidden sm:inline">|</span>
                  )}
                </React.Fragment>
              ))}
            </div>
        </div>
          {/* Back to Top Button */}
          <div  className="group inline-flex gap-4">
          <div className="text-center mt-8">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group inline-flex items-center space-x-2 bg-gray-800 hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 text-gray-300 hover:text-white px-6 py-3 rounded-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <svg className="w-5 h-5 group-hover:animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
              </svg>
              <span className="font-medium">Back to Top</span>
            </button>
          </div>
          <div className="text-center mt-8">
             <Link to="/login"><button 
              className="group inline-flex items-center space-x-2 bg-gray-800 hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 text-gray-300 hover:text-white px-6 py-3 rounded-xl transition-all duration-300 transform hover:-translate-y-1"
            
              
              ><span className="font-medium">Admin Panel</span>
            </button>
            </Link>
          </div>
          </div>
        </div>
      </div>

      

      {/* Social Media & Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center justify-between space-y-8 lg:space-y-0">
            {/* Social Media */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-6 text-center lg:text-left">Follow Us</h4>
              <div className="flex items-center justify-center lg:justify-start space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group w-12 h-12 bg-gray-800 hover:bg-gradient-to-br hover:from-blue-500 hover:to-purple-600 rounded-xl flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl"
                    aria-label={social.name}
                  >
                    <div className="text-gray-300 group-hover:text-white transition-colors duration-300">
                      {social.icon}
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Contact Info */}
            <div className="text-center lg:text-right">
              <div className="space-y-1 mb-6">
                <div className="flex items-center justify-center lg:justify-end space-x-3">
                  <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <a href="tel:+91 98452 07846" className="text-white hover:text-blue-400 transition-colors duration-300 font-semibold">
                    +91 98452 07846
                  </a>
                </div>
                <div className="flex items-center justify-center lg:justify-end space-x-3">
                  <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a href="mailto:1thinkrealty@gmail.com" className="text-white hover:text-blue-400 transition-colors duration-300 font-semibold">
                    1thinkrealty@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-center justify-center lg:justify-end space-x-2 text-sm text-gray-400">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-white">Available 24/7 for emergencies</span>
              </div>
            </div>
          </div>
        </div>
      
    </footer>
  );
};

export default Footer;
